import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

type ToggleProps = {
  label: string;
  selectedOption: string;
  options: { label: string; value: string }[];
  onToggle: (value: string) => void;
};

export const Toggle = ({ label, selectedOption, options, onToggle, ...rest }: ToggleProps): JSX.Element => {
  const [selected, setSelected] = useState(selectedOption);

  useEffect(() => {
    setSelected(selectedOption);
  }, [selectedOption]);

  const handleToggleClick = (value: string): void => {
    setSelected(value);
    onToggle(value);
  };

  return (
    <Group role='group' aria-label={label} {...rest}>
      {options.map((option) => (
        <Option
          key={option.value}
          onClick={() => handleToggleClick(option.value)}
          disabled={selected === option.value}
          aria-pressed={selected === option.value}
        >
          {option.label}
        </Option>
      ))}
    </Group>
  );
};

const Group = styled.div`
  background: #e3e7e9;
  border: 2px solid #e3e7e9;
  border-radius: ${({ theme }) => theme.customized.radius.buttons};
`;

const Option = styled.button`
  appearance: none;
  background: none;
  border: none;
  border-radius: ${({ theme }) => theme.customized.radius.buttons};
  color: #121516;
  font-size: 14px;
  font-weight: 500;
  line-height: ${16 / 14};
  padding: 4px 10px;

  &[aria-pressed='true'] {
    background: #fff;
  }

  &[aria-pressed='false'] {
    cursor: pointer;
  }
`;
